import type { FC, PropsWithChildren } from 'react'

import { useEffect } from 'react'
import { useBoolean } from 'react-use'
import { navigatorDetector } from 'typesafe-i18n/detectors'

import { detectLocale, loadLocaleAsync, locales, i18nReact as TypesafeI18n } from '@/shared/i18n'

export const LangProvider: FC<PropsWithChildren> = ({ children }) => {
  const [localesLoaded, setLocalesLoaded] = useBoolean(false)
  const locale = detectLocale(navigatorDetector)

  useEffect(() => {
    // Load all locales (add more locales if needed)
    Promise.all(locales.map((locale) => loadLocaleAsync(locale))).then(() => setLocalesLoaded(true))
  }, [locale, setLocalesLoaded])

  if (!localesLoaded) return null

  return <TypesafeI18n locale={locale}>{children}</TypesafeI18n>
}
